import { PermissionName } from '@vetahealth/fishing-gear/permissions'

export function getManagedSiteKeys(permissions: string[]): string[] {
  return permissions
    .filter((permission) => permission.split(':')[0] === PermissionName.manageSite)
    .map((permission) => permission.split(':')[1])
}
